import classes from './title.module.css'

const Title = {
  classNames: {
    root: classes.root,
  },
}

export default Title
